export default "__VITE_ASSET__b9OgKWe5__"